import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../../../../../util/assets';
import Button from '../../../../../../../components/global/Button';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

const TagSelectionNullState = ({ albumFolder }) => {
  const tags = albumFolder.tags?.records ?? [];

  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <img
        src={getAsset('/waldo-icon-error.svg')}
        alt=""
        width="48"
        className="mb-2"
      />

      <h3>Whoops!</h3>

      {!tags.length ? (
        <p className="text-center">
          {albumFolder.name} does not contain any sports at this time. Please
          check back later.
        </p>
      ) : (
        <Fragment>
          <p className="text-center">
            We couldn&apos;t find any subscribed family members in{' '}
            <br className="d-none d-md-block" />
            <strong>{albumFolder.name}</strong>.
          </p>

          <Button
            btnBlock
            to={`/discover/album-folder/${albumFolder.id}`}
            className="d-block d-md-none mt-2"
            btnStyle="success-vibrant"
          >
            Get your photos here &rarr;
          </Button>
          <Button
            to={`/discover/album-folder/${albumFolder.id}`}
            className="d-none d-md-block px-6 mt-2"
            btnStyle="success-vibrant"
          >
            Get your photos here &rarr;
          </Button>
        </Fragment>
      )}

      <p className="text-sm text-center mt-4">
        If you feel this was a mistake please feel free to contact{' '}
        <a href="mailto:support@waldophotos.com">our support here.</a>
      </p>
    </div>
  );
};

TagSelectionNullState.propTypes = propTypes;

export default TagSelectionNullState;
